import api, { apiAdmin } from '../api';


// eslint-disable-next-line import/prefer-default-export
export async function getAllProjects() {
  const { data } = await api.post(`${apiAdmin}/getHelpProjects`, {});
  return data;
}
